import React, { Component } from "react";
import moment from "moment";
import { Modal, Checkbox, Radio, InputNumber, Table, Alert, Space, message, Tooltip } from "antd";
import { ThunderboltOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { ButtonItem, SelectEmpleadosItem } from "../../../../Components/Items";
import { cmmsPost, formatoFecha } from "../cmmsComun";
import "../cmms.css";

// "Distribuir automaticamente": reparte en dias habiles de cada vuelta los equipos del
// programa, juntando los de una misma sucursal / ubicacion para hacer una sola visita.
// Primero muestra como quedaria (simulacion) y luego se aplica. No crea servicios.
class ModalDistribuirCMMS extends Component {
    state = {
        vueltasIds: [],
        soloSinFecha: true,
        agruparPor: "sucursal",
        ingenierosIds: [],
        maxPorDia: null,
        sabados: false,
        reservarUltimaSemana: false,
        desdeHoy: true,
        resumen: null,
        cargando: false,
    };

    componentDidUpdate(prev) {
        if (this.props.visible && !prev.visible) {
            const hoy = moment().format("YYYY-MM-DD"); // dia local, no UTC
            // Por default: las vueltas que no han terminado.
            const vigentes = (this.props.contrato?.vueltas || []).filter((v) => String(v.fechaFin).slice(0, 10) >= hoy).map((v) => v._id);
            this.setState({ vueltasIds: vigentes, resumen: null }, this.simular);
        }
    }

    opciones = () => ({
        contratoId: this.props.contrato._id,
        vueltasIds: this.state.vueltasIds,
        soloSinFecha: this.state.soloSinFecha,
        agruparPor: this.state.agruparPor,
        ingenierosIds: this.state.ingenierosIds,
        maxPorDia: this.state.maxPorDia,
        sabados: this.state.sabados,
        reservarUltimaSemana: this.state.reservarUltimaSemana,
        desdeHoy: this.state.desdeHoy,
    });

    simular = async () => {
        if (!this.state.vueltasIds.length) return this.setState({ resumen: [] });
        this.setState({ cargando: true });
        try {
            const res = await cmmsPost(this.props, "distribuirCalendarioCMMS", { ...this.opciones(), simular: true });
            if (res.data.success === 2) this.setState({ resumen: res.data.resumen });
            else message.error(res.data.message || "No se pudo calcular");
        } finally {
            this.setState({ cargando: false });
        }
    };

    cambiar = (cambios) => this.setState({ ...cambios, resumen: null }, this.simular);

    aplicar = async () => {
        this.setState({ cargando: true });
        try {
            const res = await cmmsPost(this.props, "distribuirCalendarioCMMS", this.opciones());
            if (res.data.success !== 2) return message.error(res.data.message || "No se pudo distribuir");
            message.success(`${res.data.asignados} servicio(s) calendarizados`);
            this.props.onClose(true);
        } finally {
            this.setState({ cargando: false });
        }
    };

    render() {
        const { visible, contrato } = this.props;
        const resumen = this.state.resumen || [];
        const total = resumen.reduce((a, r) => a + r.asignados, 0);
        const sinLugar = resumen.reduce((a, r) => a + r.sinLugar, 0);
        const ayuda = (t) => (
            <Tooltip title={t}>
                <QuestionCircleOutlined style={{ color: "#9aa7b4" }} />
            </Tooltip>
        );
        return (
            <Modal
                className="cmms-modal"
                visible={visible}
                onCancel={() => this.props.onClose(false)}
                width={window.innerWidth > 980 ? 900 : "96%"}
                footer={
                    <div className="cmms-modal-pie" style={{ padding: 0, border: 0 }}>
                        <span className="cmms-modal-pie-nota">Sólo se ponen fechas: ninguna Orden de Servicio se crea.</span>
                        <ButtonItem type="default" onClick={() => this.props.onClose(false)}>
                            Cancelar
                        </ButtonItem>
                        <ButtonItem type="primary" icon={<ThunderboltOutlined />} loading={this.state.cargando} disabled={!total} onClick={this.aplicar}>
                            Calendarizar {total || ""}
                        </ButtonItem>
                    </div>
                }
                title={
                    <div className="cmms-modal-titulo">
                        <ThunderboltOutlined style={{ fontSize: 20, color: "#2fb8d6" }} />
                        <div>
                            <div className="cmms-modal-titulo-texto">Distribuir automáticamente</div>
                            <div className="cmms-modal-subtitulo">Reparte los equipos en los días hábiles de cada vuelta, juntando los de una misma sucursal para hacer una sola visita.</div>
                        </div>
                    </div>
                }
            >
                <div className="cmms-modal-cuerpo" style={{ paddingBottom: 12 }}>
                    <div className="cmms-distribuir">
                        <div>
                            <div className="cmms-etiqueta-campo">Vueltas</div>
                            <Checkbox.Group
                                options={(contrato?.vueltas || []).map((v) => ({ label: `${v.nombre} (${formatoFecha(v.fechaInicio)} – ${formatoFecha(v.fechaFin)})`, value: v._id }))}
                                value={this.state.vueltasIds}
                                onChange={(vueltasIds) => this.cambiar({ vueltasIds })}
                            />
                        </div>
                        <div>
                            <div className="cmms-etiqueta-campo">Qué equipos</div>
                            <Radio.Group value={this.state.soloSinFecha} onChange={(e) => this.cambiar({ soloSinFecha: e.target.value })}>
                                <Space direction="vertical">
                                    <Radio value={true}>Sólo los que no tienen fecha</Radio>
                                    <Radio value={false} disabled={this.props.puedeMover === false}>
                                        Todos los pendientes (vuelve a repartir lo ya calendarizado){this.props.puedeMover === false ? " · requiere el permiso Mover en la agenda" : ""}
                                    </Radio>
                                </Space>
                            </Radio.Group>
                        </div>
                        <div>
                            <div className="cmms-etiqueta-campo">Juntar por {ayuda("Los equipos del mismo grupo quedan en días seguidos y con el mismo ingeniero.")}</div>
                            <Radio.Group value={this.state.agruparPor} onChange={(e) => this.cambiar({ agruparPor: e.target.value })}>
                                <Radio value="sucursal">Sucursal</Radio>
                                <Radio value="ubicacion">Sucursal y ubicación</Radio>
                                <Radio value="area">Ubicación y área</Radio>
                                <Radio value="ninguno">No juntar</Radio>
                            </Radio.Group>
                        </div>
                        <div>
                            <div className="cmms-etiqueta-campo">Ingenieros {ayuda("Opcional. Cada sucursal (grupo) se le da completa al que lleva menos equipos. Vacío = se conserva el que ya tengan.")}</div>
                            <SelectEmpleadosItem
                                empresaId={this.props.empresaId}
                                headersToken={this.props.headersToken}
                                width="100%"
                                mode="multiple"
                                placeholder="Conservar el asignado"
                                value={this.state.ingenierosIds}
                                onChange={(ingenierosIds) => this.cambiar({ ingenierosIds: ingenierosIds || [] })}
                            />
                        </div>
                        <div style={{ display: "flex", gap: 16, flexWrap: "wrap", alignItems: "center" }}>
                            <span>
                                Máximo por día {ayuda("Entre todos los ingenieros. Vacío = el mínimo para que todo quepa en la vuelta.")}{" "}
                                <InputNumber min={1} max={200} size="small" placeholder="Auto" value={this.state.maxPorDia} onChange={(maxPorDia) => this.cambiar({ maxPorDia: maxPorDia || null })} style={{ width: 80 }} />
                            </span>
                            <Checkbox checked={this.state.sabados} onChange={(e) => this.cambiar({ sabados: e.target.checked })}>
                                Incluir sábados
                            </Checkbox>
                            <Checkbox checked={this.state.reservarUltimaSemana} onChange={(e) => this.cambiar({ reservarUltimaSemana: e.target.checked })}>
                                Dejar libre la última semana de cada mes {ayuda("Para reportes adicionales, mantenimientos pendientes y capacitación (como el Planeador de Santa Catarina).")}
                            </Checkbox>
                            <Checkbox checked={this.state.desdeHoy} onChange={(e) => this.cambiar({ desdeHoy: e.target.checked })}>
                                No poner fechas pasadas
                            </Checkbox>
                        </div>
                    </div>
                    <div className="cmms-etiqueta-campo" style={{ marginTop: 14 }}>
                        Así quedaría
                    </div>
                    <Table
                        size="small"
                        rowKey="vueltaId"
                        loading={this.state.cargando}
                        pagination={false}
                        dataSource={resumen}
                        locale={{ emptyText: "Elija al menos una vuelta" }}
                        columns={[
                            { title: "Vuelta", dataIndex: "nombre" },
                            { title: "Equipos", dataIndex: "planes", width: 80, align: "right" },
                            { title: "Grupos", dataIndex: "grupos", width: 75, align: "right" },
                            { title: "Días hábiles", dataIndex: "diasHabiles", width: 100, align: "right" },
                            { title: "Por día", dataIndex: "porDia", width: 75, align: "right" },
                            { title: "Del", dataIndex: "primera", width: 110, render: (v) => (v ? formatoFecha(`${v}T12:00:00Z`) : "—") },
                            { title: "Al", dataIndex: "ultima", width: 110, render: (v) => (v ? formatoFecha(`${v}T12:00:00Z`) : "—") },
                            { title: "Sin lugar", dataIndex: "sinLugar", width: 85, align: "right", render: (v) => (v ? <b style={{ color: "#d64545" }}>{v}</b> : 0) },
                        ]}
                    />
                    {sinLugar > 0 && <Alert type="warning" showIcon style={{ marginTop: 8 }} message={`${sinLugar} equipo(s) no caben con el máximo por día elegido: quedarán sin fecha.`} />}
                    {resumen.length > 0 && !total && !this.state.cargando && (
                        <Alert type="info" showIcon style={{ marginTop: 8 }} message="No hay equipos por calendarizar en esas vueltas (o la vuelta ya terminó y está marcado 'No poner fechas pasadas')." />
                    )}
                </div>
            </Modal>
        );
    }
}

export default ModalDistribuirCMMS;
